// Пример цвета1 (в формате HEX)

// Изменение оттенка (например, на 180 градусов)
export function changeHue(color, degrees) {
  // Преобразование HEX в RGB
  color = color.slice(1); // Удаляем решетку
  const r = parseInt(color.slice(0, 2), 16);
  const g = parseInt(color.slice(2, 4), 16);
  const b = parseInt(color.slice(4, 6), 16);

  // Вычисляем новый оттенок
  const newHSLColor = rgbToHSL({ r, g, b });
  newHSLColor.h = (newHSLColor.h + degrees) % 360;

  // Преобразование HSL обратно в HEX
  return hslToHex(newHSLColor);
}

// Изменение насыщенности (например, увеличение на 20%)
export function changeSaturation(color, percentage) {
  // Преобразование HEX в RGB
  color = color.slice(1); // Удаляем решетку
  const r = parseInt(color.slice(0, 2), 16);
  const g = parseInt(color.slice(2, 4), 16);
  const b = parseInt(color.slice(4, 6), 16);

  // Вычисляем новую насыщенность
  const newHSLColor = rgbToHSL({ r, g, b });
  newHSLColor.s = Math.min(100, newHSLColor.s + percentage);

  // Преобразование HSL обратно в HEX
  return hslToHex(newHSLColor);
}

// Изменение яркости (например, увеличение на 20%)
export function changeBrightness(color, percentage) {
  // Преобразование HEX в RGB
  color = color.slice(1); // Удаляем решетку
  const r = parseInt(color.slice(0, 2), 16);
  const g = parseInt(color.slice(2, 4), 16);
  const b = parseInt(color.slice(4, 6), 16);

  // Вычисляем новую яркость
  const newHSLColor = rgbToHSL({ r, g, b });
  newHSLColor.l = Math.min(100, newHSLColor.l + percentage);

  // Преобразование HSL обратно в HEX
  return hslToHex(newHSLColor);
}

// Преобразование RGB в HSL
function rgbToHSL(rgbColor) {
  const r = rgbColor.r / 255;
  const g = rgbColor.g / 255;
  const b = rgbColor.b / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h,
    s,
    l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // оттенок, насыщенность и яркость равны
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }

  return {
    h: Math.round(h * 360),
    s: Math.round(s * 100),
    l: Math.round(l * 100),
  };
}

// Преобразование HSL в HEX
function hslToHex(hslColor) {
  const h = hslColor.h / 360;
  const s = hslColor.s / 100;
  const l = hslColor.l / 100;
  let r, g, b;

  if (s === 0) {
    r = g = b = l;
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };

    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;

    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  r = Math.round(r * 255);
  g = Math.round(g * 255);
  b = Math.round(b * 255);

  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b
    .toString(16)
    .padStart(2, "0")}`;
}

export const hexToRgba = (hex, alpha = 0.1) => {
  const color = hex.slice(1); // Удаляем решетку
  const r = parseInt(color.slice(0, 2), 16);
  const g = parseInt(color.slice(2, 4), 16);
  const b = parseInt(color.slice(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// Преобразование цвета в пастельный оттенок
export function toPastel(color) {
  // Преобразование HEX в RGB
  color = color.slice(1); // Удаляем решетку
  const r = parseInt(color.slice(0, 2), 16);
  const g = parseInt(color.slice(2, 4), 16);
  const b = parseInt(color.slice(4, 6), 16);

  // Преобразуем в HSL для работы с насыщенностью
  const hsl = rgbToHSL({ r, g, b });

  // Уменьшаем насыщенность и увеличиваем яркость для пастельного эффекта
  hsl.s = Math.min(100, hsl.s * 0.5); // Уменьшаем насыщенность на 50%
  hsl.l = Math.min(100, hsl.l + 20); // Увеличиваем яркость на 20%

  // Преобразуем обратно в HEX
  return hslToHex(hsl);
}